module.exports = __webpack_public_path__ + "static/media/instructions.6237c826.svg";